// runOutcome.js — renderer MIRROR of apolo-api/src/hermes/domain/runOutcome.js
// (E1 honesty). Keep ACTION_TOOLS identical across the two copies (the backend
// must never import the frontend package and vice-versa). Pure, framework-free.
//
// "acted" = the run did something EFFECTING (web_act / run_command / file write /
// radar_emit) vs only NARRATED. The Hermes executor counts effecting tool_call
// events during the loop and reports the count on finalize so the UI can show
// "concluiu sem ações" instead of fake success-green.

export const ACTION_TOOLS = Object.freeze([
  'web_act',
  'run_command',
  'write_file',
  'edit_file',
  'apply_patch',
  'radar_emit',
]);

export function isActionTool(name) {
  return ACTION_TOOLS.includes(name);
}

export function classifyActed({ actionToolCalls = 0, conversational = false } = {}) {
  if (Number(actionToolCalls) > 0) return 1;
  if (conversational) return 1;
  return 0;
}

export function countActionToolCalls(toolCallNames = []) {
  let n = 0;
  for (const name of toolCallNames) if (isActionTool(name)) n += 1;
  return n;
}
